import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeLeaveRequest  {
    _originalTypeClassName = "zSHR.BO.EmployeeLeaveRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeLeaveRequest.translate = translateService;
}
this.Id = null;
this.DateRequested = null;
this.DateFrom = null;
this.DateTo = null;
this.WorkingDays = null;
this.EmployeeNotes = null;
this.HRNotes = null;
this.FlowStepIndex = null;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateRequested:any;
DateFrom:any;
DateTo:any;
WorkingDays:any;
EmployeeNotes:any;
HRNotes:any;
FlowStepIndex:any;
Status:any;
EmployeeLeave:any;
Employee:any;
LeaveRule:any;
static setEmployeeLeave = ($this, value) => {
var oldValue = $this.EmployeeLeave;
$this.EmployeeLeave = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setLeaveRule = ($this, value) => {
var oldValue = $this.LeaveRule;
$this.LeaveRule = value;
if (value != null) {
}
}

static ToCalendarEvent($this: any): any{let event = new Domain.CalendarEvent();
event.Id = Joove.Common.safeNumber($this?.Id) + "";
event.Title = $this?.EmployeeLeave?.EmployeeContract?.Employee?.Fullname;
event.Start = $this?.DateFrom;
event.End = $this?.DateTo;
if ($this?.Status == Domain.LeaveRequestStatus.Pending) {let pendingColor = "#CACED5";event.backgroundColor = pendingColor;event.borderColor = pendingColor;}
return event;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}